import React, { useState, useEffect } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Col, Container, Row } from "react-bootstrap";
import { getApiClient } from "../../libs/axiosInstance";
import { LucideSparkles } from "lucide-react";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

export default function TopSalesCard({ data, recs = "" }) {
  const [topProducts, setTopProducts] = useState(data ?? []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTopProducts = async () => {
      try {
        const response = await getApiClient().get("/api/sales/top");
        setTopProducts(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch top products.");
      } finally {
        setLoading(false);
      }
    };
    if (data === undefined) {
      fetchTopProducts();
    }
  }, []);
  useEffect(() => {
    setLoading(data === null);
    setTopProducts(data);
  }, [data]);

  const chartData = {
    labels: topProducts?.map((item) => item.item),
    datasets: [
      {
        label: "Items Sold",
        data: topProducts?.map((item) => item.totalSold),
        backgroundColor: [
          "rgba(54, 162, 235, 0.7)", // Blue
          "rgba(255, 206, 86, 0.7)", // Yellow
          "rgba(75, 192, 192, 0.7)", // Teal
          "rgba(255, 99, 132, 0.7)", // Pink
          "rgba(153, 102, 255, 0.7)", // Purple
        ],
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  return (
    <div
      className="graph-header"
      style={{
        backgroundColor: "transparent",
      }}
    >
      <h2>Top Products</h2>
      <Container fluid>
        <Row>
          <div className="col-12">
            {!loading && topProducts.length === 0 && (
              <div className="alert alert-danger w-100">Not enough data</div>
            )}
          </div>
          <div className="col-12">
            <Row>
              <Col xl={6}>
                <Row>
                  <Col xl={4} lg={4} md={4}>
                    {loading && <p>Loading top products...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {!loading && !error && topProducts.length > 0 && (
                      <div className="custom_sale_chart">
                        <Doughnut
                          className="doughnut_custom"
                          data={chartData}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: {
                                display: false,
                                // position: "right",
                                // labels: {
                                //   pointStyle: "circle", // Make legend color indicators circular
                                //   usePointStyle: true,
                                //   generateLabels: (chart) => {
                                //     const data = chart.data;
                                //     if (data.labels && data.datasets.length) {
                                //       return data.labels.map((label, i) => {
                                //         const value = data.datasets[0].data[i];
                                //         const backgroundColor =
                                //           data.datasets[0].backgroundColor[i];
                                //         return {
                                //           text: `${label} - ${value} items`,
                                //           fillStyle: backgroundColor,
                                //           strokeStyle: "#fff",
                                //           lineWidth: 2,
                                //           hidden: isNaN(value),
                                //           index: i,
                                //         };
                                //       });
                                //     }
                                //     return [];
                                //   },
                                // },
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                  </Col>
                  <Col xl={8} lg={8} md={8}>
                    {topProducts?.map((product, idx) => (
                      <Row key={idx} className="doughnut_items">
                        <Col>
                          <div
                            className="item_sold"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: 14,
                                height: 14,
                                borderRadius: "50%",
                                backgroundColor:
                                  chartData.datasets[0].backgroundColor[idx],
                                marginRight: 8,
                                border: "2px solid #fff",
                              }}
                            ></span>
                            {product.item}
                          </div>
                        </Col>
                        <Col>
                          <div className="item_count">{product.totalSold}</div>
                          <div className="item_crap">Item Sold</div>
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              </Col>
              <Col xl={6}>
                <Row>
                  <Col>
                    {recs ? (
                      <div className="mt-2">
                        <div className="my-1"></div>
                        <LucideSparkles /> {recs}
                      </div>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Row>
      </Container>
      {/* <ul style={{ marginTop: "15px", fontSize: "0.9em" }}>
        {topProducts?.map((product, idx) => (
          <li key={idx}>
            {product.item}: {product.totalSold} sold
          </li>
        ))}
      </ul> */}
    </div>
  );
}
